<template>
    <vue-modal :open="open">
        <div v-if="!deleteSuccess">
            <div class="bax-icon bax-remove d-flex align-items-center justify-content-center">
                <i class="icon-delete"></i>
            </div>
            <h2>Remove Drug Item?</h2>
            <p>
                This will remove
                <strong>
                    <span v-if="drug.drug1_name">{{ drug.drug1_name }}</span>
                    <span v-else-if="drug.description">{{ drug.description }}</span>
                </strong>
                <span v-if="patient.firstName !== ''"> for {{ patient.firstName }} {{ patient.lastName }}</span>
            </p>
            <div class="bax-modal-action-items">
                <ul class="d-md-flex justify-content-center">
                    <li>
                        <a href="#" @click.prevent="closeModal" class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1">Cancel</a>
                    </li>
                    <li>
                        <a href="#" @click.prevent="confirm" class="bax-btn bax-btn-orange mt-3 mt-md-0">Remove item</a>
                    </li>
                </ul>
            </div>
        </div>
        <div v-if="deleteSuccess">
            <div class="bax-modal-content bax-modal-icon-content text-center">
                <div class="bax-icon bax-success d-flex align-items-center justify-content-center">
                    <i class="icon-tick"></i>
                </div>
                <h2>Drug Item Removed</h2>
                <p>
                    Drug item
                    <strong>{{ drug.drug1_name }}</strong> has been removed!
                </p>
                <div class="bax-modal-action-items">
                    <ul class="d-md-flex justify-content-center">
                        <li>
                            <a href="#" @click.prevent="closeModal" class="bax-btn bax-btn-bordered bax-btn-bordered-dark-gray-1">Close</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
    </vue-modal>
</template>

<script>
import DrugService from '@/core/api/drug/drug.service';

export default {
    name: 'DrugDeleteConfirmModal',
    props: {
        open: {
            default: false,
            type: Boolean,
        },
        drug: {
            type: Object,
        },
        patient: {
            type: Object,
        },
    },
    data() {
        return {
            deleteSuccess: false,
        };
    },
    methods: {
        closeModal() {
            this.deleteSuccess = false;
            this.$emit('cancel');
        },
        confirm() {
            DrugService.deleteDrugFromOrder({
                orderRef: this.$route.params.orderId,
                drugPresentationId: this.drug.drugPresentationId,
                patientId: this.drug.patientId,
                orderLineItemId: this.drug.orderLineItemId,
            })
                .then(() => {
                    this.deleteSuccess = true;
                    this.$emit('delete-success');
                })
                .catch(() => {
                    //
                })
                .then(() => {
                    //
                });
        },
    },
};
</script>

<style scoped>
h2, p {
    color: #4e4e4e !important;
}
</style>
